// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f26a86f7","453":"e144c2f8","732":"49eeb806","977":"87256052"}[chunkId] + ".chunk.js";
};